export function validateFileExtension(fileName, name) {
  let allowedExtensions = ["png", "jpg", "jpeg", "jfif"];
  if (name === "walkThroughImage") {
    allowedExtensions = [...allowedExtensions, "gif"];
  }
  const fileExtension = fileName.split(".").pop().toLowerCase();
  return allowedExtensions.indexOf(fileExtension) !== -1;
}

const validEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export function validateEmail(email) {
  return validEmail.test(email);
}